import { FC } from 'react';

import { Trans, useTranslation } from '@mint-lib/i18n';
import styled, { css } from '@mint-lib/styled';
import { Link } from '@mint/routing';

import { Box, Typography } from '@myn/mui';

const EmptyItem: FC = () => {
  const { t } = useTranslation('@myn/planning');

  return (
    <Wrapper>
      <Typography variant="bodyShort01" component="p">
        {t('There are no integrations.')}
      </Typography>
      <Typography variant="bodyShort01">
        <Trans
          i18nKey="Please go to the <Link>Integration Page</Link> and add a new integration."
          t={t}
          components={{
            Link: <StyledLink to={'/company-profile/integrations'} />,
          }}
        />
      </Typography>
    </Wrapper>
  );
};

export default EmptyItem;

const Wrapper = styled(Box)`
  ${({ theme }) => css`
    padding: ${theme.spacing(2.5)} ${theme.spacing(1.5)};
    border-radius: 4px;
    border: 1px solid ${theme.palette.ui.tertiary};
    color: ${theme.palette.text.placeholder};
    text-align: center;
  `}
`;

const StyledLink = styled(Link)`
  ${({ theme }) => css`
    font-size: 0.875rem;
    font-weight: 700;
    color: ${theme.palette.text.placeholder};
    text-decoration: none;
  `}
`;
